import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ITeamMemberLastSelectedState } from '~/types/teamMember/models'

const teamMemberLastSelectedStateListData =
  undefined as unknown as ITeamMemberLastSelectedState[]

export const getTeamMemberLastSelectedStateListData =
  getListDataFunctionFactory<ITeamMemberLastSelectedState[]>({
    listData: teamMemberLastSelectedStateListData,
    storageKey: 'teammemberlastselectedstates',
    getStartingListData: getStartingTeamMemberLastSelectedStateListData,
  })

export async function getTeamMemberLastSelectedStateData(
  id: TEntityId
): Promise<ITeamMemberLastSelectedState> {
  const list: ITeamMemberLastSelectedState[] =
    await getTeamMemberLastSelectedStateListData()
  if (!list) {
    throw new Error(
      `getTeamMemberLastSelectedStateList returned undefined/null`
    )
  }
  const teamMemberLastSelectedState = list.find((tmlsd) => tmlsd.id === id)
  if (!teamMemberLastSelectedState) {
    throw new Error(`Can't find teamMemberLastSelectedState '${id}'`)
  }
  return teamMemberLastSelectedState
}

export async function getTeamMemberLastSelectedStateDataByTeamMemberId(
  id: TEntityId
): Promise<ITeamMemberLastSelectedState | undefined> {
  const list: ITeamMemberLastSelectedState[] =
    await getTeamMemberLastSelectedStateListData()
  if (!list) {
    throw new Error(
      `getTeamMemberLastSelectedStateList returned undefined/null`
    )
  }
  const teamMemberLastSelectedState = list.find((tmlsd) =>
    isEqual(tmlsd.teamMemberId, id)
  )
  return teamMemberLastSelectedState
}

export async function getStartingTeamMemberLastSelectedStateListData(): Promise<
  ITeamMemberLastSelectedState[]
> {
  return []
}
